
// Global elements for frequently used nodes
const cartDrawer = document.querySelector(".cart-drawer");
const body = document.body;
const quantityDisplays = document.querySelectorAll(".quantity");

const cartIcon = document.querySelector(".icon2");
const ecoBadge = document.querySelector(".eco-badge");
const innerCart = document.querySelector('.inner_cart');
const removeBtn3 = document.querySelector('#remove-cartdrawer')
function formatPrice(priceInCents) {
  // Divide by 100 to convert cents to dollars

  const dollars = priceInCents / 100

  // Format as USD currency
  return `$${dollars.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}




// Fetch and update cart data
const fetchCartData = async (form) => {
  if (!form) {
    console.error("Form not found.");
    return;
  }



  const response1 = await fetch("/cart/add", {
    method: "POST",
    body: new FormData(form),
  });

  const response = await fetch("/cart.js");
  const cart = await response.json();

  await updateCartDrawer();


};


const totalPriceFetch = async () => {
  try {
    console.log("function2 run")
    const response = await fetch("/?section_id=cart-drawer");
    const response2 = await fetch("/?section_id=cart-main");

    const html = await response.text();
    const html2 = await response2.text();
    const newContent = new DOMParser().parseFromString(html, "text/html").querySelector(".total_amount");
    const newContent2 = new DOMParser().parseFromString(html2, "text/html").querySelector(".total_amount");

    if (newContent) {
      document.querySelector('.total_amount').innerHTML =newContent.innerHTML
    }
    if (newContent2) {
      document.querySelector('.total_amount').innerHTML =newContent2.innerHTML
    }


  } catch (error) {
    console.log("error while fetching total price",error)
  }

}


// Cart drawer control functions
const openCartDrawer = () => {
  cartDrawer.classList.add("cart-drawer--active");
  body.style.overflowY = "hidden";
};

const closeCartDrawer = () => {
  cartDrawer.classList.remove("cart-drawer--active");
  body.style.overflowY = "scroll";
};

// Setup submit button for adding to cart
const setupSubmitButton = () => {
  const submitButtons = document.querySelectorAll(".product-form__submit");
  if (submitButtons) {

    submitButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const parentForm = e.target.closest('form')

      e.preventDefault();
      console.log("Button clicked");
      fetchCartData(parentForm).then(() => {
        openCartDrawer();
      });
    })
    })
  }
};


const addCartDrawerListeners = () => {
  document.querySelectorAll('.increase , .decrease ').forEach((button) => {
    button.addEventListener("click", async () => {
      const Subroot = button.closest('.cardDetail')
      const itemTotal = Subroot.querySelector('.cardprice')
      const rootItem = button.closest(".card");
      const key = rootItem.getAttribute("data-line-item-key");
      const quantityInput = button.parentElement.querySelector(".quantity");
      let currentQuantity = Number(quantityInput.innerText);
      const isIncrease = button.classList.contains("cart-drawer-quantity-selector-plus");
      const newQuantity = isIncrease ? currentQuantity + 1 : Math.max(currentQuantity - 1, 1);

      quantityInput.innerHTML = newQuantity


     const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
    });


      const data = await response.json()



      document.querySelector('.total_amount').innerText = formatPrice(data.total_price)
      Subroot.querySelector('.cardprice').textContent= formatPrice(data.items[rootItem.dataset.index].final_line_price)
    });
  });


  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer .close-btn").forEach((el) => {
    el.addEventListener("click", closeCartDrawer);
  });

  document.querySelector(".icon2").addEventListener("click", openCartDrawer);


  cartDrawer.addEventListener('click', (event) => {

    const SideCartDrawer=document.querySelector('#cart-drawer')
    if (!SideCartDrawer.contains(event.target) && event.target.id !== 'remove-cartdrawer' ) {
       closeCartDrawer()
    }
  })
};









// Update the cart drawer content dynamically
const updateCartDrawer = async () => {
  try {
    const response = await fetch("/?section_id=cart-drawer");
    const response2 = await fetch("/?section_id=cart-main");

    const html = await response.text();
    const html2 = await response2.text();
    const newContent = new DOMParser().parseFromString(html, "text/html").querySelector("#shopify-section-cart-drawer");
    const newContent2 = new DOMParser().parseFromString(html2, "text/html").querySelector(".main-cart__layout");

    if (newContent) {
      document.querySelector("#shopify-section-cart-drawer").innerHTML = newContent.innerHTML;
      setupRemoveButtons();
      addCartDrawerListeners();

    }

    if (newContent2) {
      const oldNode = document.querySelector('.main-cart__layout');
      innerCart.replaceChild(newContent2, oldNode);
      setupRemoveButtons();
      addCartDrawerListeners();
      ecoBadge.style.display = document.querySelectorAll(".carditem").length === 0 ? "none" : "flex";

    }

  } catch (error) {
    console.error("Error updating the cart drawer:", error);
  }
};

// Remove item from the cart
const removeCartItem = async (id) => {
  try {
 await fetch(`/cart/change?id=${id}&quantity=0`, { method: "POST" });

  } catch (error) {
    console.log("Error while removing item", error);
  }
};

// Setup remove button listeners
const setupRemoveButtons = () => {
  const removeBtn = document.querySelectorAll('.remove-btn')
  removeBtn.forEach((button) => {
    button.addEventListener("click", async () => {
   console.log('click on remove')
      const rootItem = button.closest(".card");
      const lineItemKey = rootItem.getAttribute("data-line-item-key");



      document.querySelectorAll('[model="cart"]').forEach((el, index) => {
        if (el.contains(rootItem)) {
          el.removeChild(rootItem);

          console.log(index)
          document.querySelector(`.bag_value`).innerHTML = `(${el.childElementCount} items)`;
        }

      });



      button.disabled = true;
      await removeCartItem(lineItemKey);
      await totalPriceFetch()
      button.disabled = false;
    });
  });
};

// Initialization
setupSubmitButton();
addCartDrawerListeners();
setupRemoveButtons();
